import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule
  ],
  declarations: [HowItWorksComponent],
  exports: [HowItWorksComponent]
})
export class HowItWorksModule { }
